<template>
    <button @click="copyLink" v-bind="$attrs">
        <svg class="icon" aria-label="주소 복사" :width="size" :height="size" :viewBox="`0 0 48 48`" preserveAspectRatio="xMidYMid meet">
            <g fill="none" fill-rule="evenodd">
                <path fill="#35C5F0" d="M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z"></path>
                <path fill="#FFF" d="M16.138 29.182c-2.282 0-3.836-1.246-3.836-4.606v-5.88h1.624v5.992c0 2.324.924 3.08 2.212 3.08 1.302 0 2.254-.756 2.254-3.08v-5.992h1.568v5.88c0 3.36-1.54 4.606-3.822 4.606zm8.106-9.184v3.542h1.554c1.498 0 2.31-.616 2.31-1.862s-.812-1.68-2.31-1.68h-1.554zM30.082 29h-1.834l-2.338-4.158h-1.666V29H22.62V18.696h3.374c2.128 0 3.724.756 3.724 2.982 0 1.596-.854 2.548-2.156 2.954L30.082 29zm1.708 0V18.696h1.624v8.932h4.354V29H31.79z"></path>
            </g>
        </svg>
        <span>URL 복사</span>
    </button>
</template>

<script>
export default {
    props: {
        size: { type: String, default: "60" },
    },
    methods: {
        copyLink() {
            navigator.clipboard.writeText(window.location.href);
            alert("복사되었습니다.");
        },
    },
};
</script>
